module.exports = "<div ontouchstart=\"var event=arguments[0];event.stopPropagation()\" ontouchend=\"var event=arguments[0];event.stopPropagation()\" class=gz-grid-menu-container></div>";


//////////////////
// WEBPACK FOOTER
// ../~/@printos/gazelle/src/extensions/grid/grid-dummy.jade
// module id = 260
// module chunks = 0